"use client"

import LoginModal, { LoginModalRef } from "@/components/authen/login/LoginModal"
import SignupModal, { SignupModalRef } from "@/components/authen/signup/SignupModal"
import { Button, Col, Row } from "antd"
import { useRef, useCallback } from "react"
import { useTranslation } from "react-i18next"

const BasicLayoutAuthen = () => {
  const refLoginModal = useRef<LoginModalRef>(null)
  const refSignupModal = useRef<SignupModalRef>(null)
  const { t } = useTranslation()

  const handleSwitchToSignup = useCallback(() => {
    refLoginModal.current?.close();
    refSignupModal.current?.open();
  }, []);

  const handleSwitchToLogin = useCallback(() => {
    refSignupModal.current?.close();
    refLoginModal.current?.open();
  }, []);

  return (
    <Col>
      <LoginModal ref={refLoginModal} onSwitchToSignup={handleSwitchToSignup} />
      <SignupModal ref={refSignupModal} onSwitchToLogin={handleSwitchToLogin} />
      <Row gutter={[10, 10]}>
        <Col>
          <Button size='large' onClick={() => refLoginModal.current?.open()} type='primary' ghost>
            {t("common.login")}
          </Button>
        </Col>

        <Col>
          <Button size='large' onClick={() => refSignupModal.current?.open()} type='primary'>
            {t("common.register")}
          </Button>
        </Col>
      </Row>
    </Col>
  )
}

export default BasicLayoutAuthen